import {Grid} from "@material-ui/core";
import {Typography} from "../../../../components/Wrappers/Wrappers";
import {format_date} from "../../../../utils";
import _ from "lodash";
import {BASE_URL} from "../../../../datamanagement/network";
import Widget from "../../../../components/Widget/Widget";
import React from "react";


const Metadaten = ({classes, jobTypes, currentJob}) => {
    return (
        <Widget
            title="Metadaten"
            upperTitle
            disableWidgetMenu
            bodyClass={classes.fullHeightBody}
            className={classes.card}
        >

            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Standort
                    </Typography>
                    <Typography color="text" size="md">{currentJob.location}</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Kategorie
                    </Typography>
                    <Typography color="text" size="md">{currentJob.category}</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Vertragsart
                    </Typography>
                    <Typography color="text" size="md">{jobTypes}</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Schaltungsdatum
                    </Typography>
                    <Typography color="text"
                                size="md">{format_date(currentJob.created_at)}</Typography>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                className={classes["secondRow"]}
            >

                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Offline ab
                    </Typography>
                    <Typography color="text"
                                size="md">{format_date(currentJob.finished_at)}</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Bewerbungen gehen an
                    </Typography>
                    {currentJob.application_type === "email" &&
                    <Typography color="text" size="md"
                                className={classes.dontBreakOut}>{currentJob.application_destination}</Typography>}
                    {currentJob.application_type === "clickout" &&
                    <Typography color="text" size="md" className={classes.dontBreakOut}>
                        <a href={currentJob.application_destination} target={"_blank"}
                           rel="noopener noreferrer">
                            {_.truncate(currentJob.application_destination)}
                        </a>
                    </Typography>}
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        JobNinja Id
                    </Typography>
                    {currentJob.finished ?
                        <Typography color="text" size="md">
                            {currentJob.id}
                        </Typography>:
                        <Typography size="md">
                            <a href={`${BASE_URL}/jobs/${currentJob.id}`} target='_blank'
                               rel="noopener noreferrer">
                                {currentJob.id}
                            </a>
                        </Typography>
                    }

                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    {!!_.trim(currentJob.id_in_source).length && <>
                        <Typography color="text" colorBrightness="secondary" noWrap>
                            Posting Id
                        </Typography>
                        <Typography size="sm">{currentJob.id_in_source}</Typography>
                    </>}
                </Grid>

            </Grid>
        </Widget>
    )
}

export default Metadaten;